import GenericModel from 'js/models/generic.model';

export default GenericModel.extend({
    defaults: {
        additionalInfo: "",
        backgroundColor: "business1",
        backgroundImagePosition: 1,
        fontColor: "bgbusiness1",
        footerText: "",
        logoContentId: null,
        pageText: "",
        pageTitleText: "",
        subFooterText: ""
    }
});
